import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Myanmar National Registration Card validator following Single Responsibility Principle
 */
export class MmValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Myanmar NRC',
      pattern: /^\d{1,2}\/[A-Z]{6}\([A-Z]\)\d{6}$/i,
      minLength: 14,
      maxLength: 18
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    if (upperCaseId.length < this.config.minLength || upperCaseId.length > this.config.maxLength) {
      return ValidationResult.invalid('Myanmar NRC length must be between 14-18 characters');
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'Myanmar NRC format must be XX/XXXXXX(X)XXXXXX'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    
    // Extract components
    const parts = upperCaseId.split('/');
    if (parts.length !== 2) {
      return ValidationResult.invalid('Invalid NRC format - missing /');
    }
    
    const stateCode = parts[0];
    const remaining = parts[1];
    
    // Validate state code (1-14)
    const stateNum = parseInt(stateCode);
    if (stateNum < 1 || stateNum > 14) {
      return ValidationResult.invalid('Invalid state code - must be 1-14');
    }

    return ValidationResult.valid('Valid Myanmar NRC');
  }
}